import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useDeleteInvoiceMutation } from '../../hooks';
import { i18n } from '../../i18n';
import { MESSAGES } from '../../const';

interface InvoiceDeleteModalType {
  invoiceId: string;
  invoiceNumber?: string;
  submitClick: () => void;
  open: () => void;
}

export const invoiceDeleteModal: InvoiceDeleteModalType = {
  invoiceId: '',
  invoiceNumber: '',
  submitClick: () => null,
  open: () => null,
};

export const InvoiceDeleteModal = () => {
  const { mutate, isLoading } = useDeleteInvoiceMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    invoiceDeleteModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    invoiceDeleteModal.invoiceId = '';
    invoiceDeleteModal.invoiceNumber = '';
    setOpen(false);
  };

  const handleSubmitClick = () => {
    if (!invoiceDeleteModal.invoiceId) return;

    mutate(invoiceDeleteModal.invoiceId, {
      onSuccess: () => {
        setOpen(false);
        enqueueSnackbar(MESSAGES.INVOICE.SUCCESS.DELETED, 'success');
        invoiceDeleteModal.submitClick();
      },
    });
  };

  return (
    <ModalBase id={'invoice-delete-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.invoiceDeleteTitle')}: {invoiceDeleteModal.invoiceNumber}
        </Typography>

        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose} disabled={isLoading}>
            {i18n.t('button.cancel')}
          </Button>
          <Button
            size={'medium'}
            data-color={'primary'}
            onClick={handleSubmitClick}
            disabled={isLoading}
          >
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
